
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/store",
      function () {
        return require("private-next-pages/[region]/[locale]/store.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/store"])
      });
    }
  